import React from 'react';

import Subheader from 'material-ui/Subheader';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ActionPublication from 'material-ui/svg-icons/action/book'

const h2Icon = {
  marginLeft: 24,
  marginRight: 24,
};

let page = (props) => (
  <div>
    <h2><ActionPublication style={h2Icon} />Publications</h2>
    <List>
      
      <Divider inset="true" />
      <Subheader inset={true}>Book Chapters</Subheader>
	  <ListItem
  	    primaryText={
    	  <span>
      	    Molléri, J. S., & Petersen, K. <strong>Teaching Research Design in Software Engineering.</strong> 
      	    In D. Mendez, P. Avgeriou, M. Kalinowski, & N. bin Ali (Eds.), <em>Handbook on Teaching Empirical Software Engineering</em>, 
      	    (pp. TBD). Springer Cham, 2024. <em>arXiv preprint arXiv:2407.05184</em>.
    	    </span>
  	      }
  	    disabled="true"
  	    insetChildren="true"
	  />
      
      <Divider inset="true" />
      <Subheader inset={true}>Standards and Guidelines</Subheader>
      <ListItem
        primaryText={<span>Mendez, D., Molléri, J. S. & Torchiano, M. (2020). <strong>ACM SIGSOFT empirical standards: Questionnaire Survey.</strong> arXiv preprint arXiv:2010.03525, 2020.</span>}
        disabled="true"
        insetChildren="true"
      />
      
      <Divider inset="true" />
      <Subheader inset={true}>Journals</Subheader><ListItem
	    primaryText={<span>Molléri, J. S., & Mohagheghi, P. <strong>Transformation to a hybrid workplace: A Case from the Norwegian Public Sector.</strong> IEEE Software, 2024.</span>}
	    disabled="true"
  		insetChildren="true"
	  />
	  <ListItem
  		primaryText={<span>Molléri, J. S., Mendes, E., Petersen, K., & Felderer, M. <strong>Determining a core view of research quality in empirical software engineering.</strong> <em>Computer Standards & Interfaces</em>, 84, 103688, 2023. North-Holland.</span>}
  		disabled="true"
  		insetChildren="true"
	  />
      <ListItem
        primaryText={<span>Molléri, J. S., Lassenius, C., & Jørgensen, M. <strong>Backsourcing of Software Development – A Systematic Literature Review.</strong> Submitted to IEEE Transactions on Software Engineering. arXiv preprint arXiv:2104.11564, 2021.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Barros-Justo, J. L., Benitti, F., & Molléri, J. S. <strong>Risks and risk mitigation in global software development: an update.</strong> Journal of Software: Evolution and Process (accepted), 2021.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Gonzalez-Huerta J., Molléri, J. S., Šablis A., & Zabardast E. <strong>Experiential Learning Approach for Software Engineering Courses.</strong> arXiv preprint arXiv:2012.14178, 2020.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Petersen, K., & Mendes, E. <strong>An Empirically Evaluated Checklist for Surveys in Software Engineering.</strong> . Information and Software Technology 119:106240, 2020. </span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Petersen, K., & Mendes, E. <strong>CERSE-Catalog for empirical research in software engineering: A Systematic mapping study.</strong> Information and Software Technology, 2018.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Petersen, K., & Mendes, E. <strong>Towards understanding the relation between citations and research quality in software engineering studies.</strong> Scientometrics, 2018.</span>}
        disabled="true"
        insetChildren="true"
      />
	  
      <Divider inset={true} />
      <Subheader inset={true}>Symposiums and Conferences</Subheader>
      <ListItem
	    primaryText={<span>Magnussen, E. F., Havnelid, E., & Molléri, J. S. <strong>The Product Owner and its Impact on Success and Challenges in Agile Scrum Projects: An Interview Study.</strong> Procedia Computer Science, 239, 1157–1164, 2024.</span>}
	    disabled="true"
		insetChildren="true"
	  />
	  <ListItem
	    primaryText={<span>Molléri, J. S. <strong>Who's actually being Studied? A Call for Population Analysis in Software Engineering Research.</strong> Proceedings of the 1st IEEE/ACM International Workshop on Methodological Issues with Empirical Studies in Software Engineering, 48–51, 2024.</span>}
	    disabled="true"
		insetChildren="true"
	  />
	  <ListItem
	    primaryText={<span>Molléri, J. S. <strong>Research incentives in academia leading to unethical behavior.</strong>In <em>International Conference on Research Challenges in Information Science</em> (pp. 744–751). Springer International Publishing Cham, 2022.</span>}
	    disabled="true"
	    insetChildren="true"
	  />
      <ListItem
        primaryText={<span>Petersen, K., & Molléri, J. S. <strong>Preliminary Evaluation of a Survey Checklist in the Context of Evidence-Based Software Engineering Education.</strong> In Proceedings of the 16th International Conference on Evaluation of Novel Approaches to Software Engineering, 2021.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Gonzalez-Huerta, J., & Henningsson, K. (2018, June). <strong>A Legacy Game for Project Management in Software Engineering Courses</strong>. In Proceedings of the 3rd European Conference of Software Engineering Education (pp. 72-76). ACM. <strong>Best Paper Award.</strong></span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., bin Ali, N., Petersen, K., Minhas, N. M., & Chatzipetrou, P. (2018, June). <strong>Teaching students critical appraisal of scientific literature using checklists.</strong> In Proceedings of the 3rd European Conference of Software Engineering Education (pp. 8-17). ACM.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Petersen, K., & Mendes, E. <strong>Survey guidelines in software engineering: An annotated review.</strong> Proceedings of the 10th ACM/IEEE International Symposium on Empirical Software Engineering and Measurement. ACM, 2016.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Marculescu, B., Jabbari, R., & Molléri, J. S. <strong>Perception of Scientific Evidence: Do Industry and Academia Share an Understanding?</strong> Lärarlärdom 2016 (2016): 121.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., & Benitti, F. B. V. <strong>SESRA: a web-based automated tool to support the systematic literature review process.</strong> Proceedings of the 19th International Conference on Evaluation and Assessment in Software Engineering. ACM, 2015.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Silva, L. E. & Benitti, F. B. V. <strong>Proposal of an Automated Approach to Support the Systematic Review of Literature Process (S).</strong> SEKE - International Conference on SEKE: Software Engineering and Knowledge Engineering. 2013.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., Benitti, F. B. V. & Fernandes. A. M. R. <strong>Aplicação de Conceitos de Inteligência Artificial na Condução de Revisões Sistemáticas: uma Resenha Crítica.</strong> Proceedings of the 6th SULCOMP - Congresso Sul Brasileiro de Computação. 2013.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., & Benitti, F. B. V. <strong>Automated Approaches to Support Secondary Study Processes: a Systematic Review.</strong> SEKE - International Conference on SEKE: Software Engineering and Knowledge Engineering. 2012.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Benitti, Fabiane Barreto Vavassori, and Molléri, J. S.. <strong>Utilização de um RPG no ensino de gerenciamento e processo de desenvolvimento de software.</strong> WEI - Workshop sobre Educação em Informática. 2008.</span>}
        secondaryText="Project: SE•RPG"
        disabled="true"
        insetChildren="true"
      />
      <Divider inset="true" />
      <Subheader inset={true}>Thesis and Reports</Subheader>
      <ListItem
        primaryText={<span>Molléri, J. S. <strong>Views of Research Quality in Empirical Software Engineering.</strong> Ph.D. Thesis, Software Engineering - Blekinge Tekniska Högskola, Karlskrona, Sweden. 2019.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S. <strong>Automatização do processo de condução de revisões sistemáticas da literatura em engenharia de software.</strong> Master Thesis, Applied Computing - Universidade do Vale do Itajaí, Itajaí, Brazil. 2013.</span>}
        secondaryText="Project: SESRA"
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText={<span>Molléri, J. S., & Benitti, F. B. V. <strong>SE•RPG: Software Engineering Role-playing Game.</strong> Technical Report (Computer Science) - Universidade do Vale do Itajaí, Itajaí, Brazil. 2006.</span>}
        secondaryText="Project: SE•RPG"
        disabled="true"
        insetChildren="true"
      />
    </List>
    <List>
      <Divider inset="true" />
      <Subheader inset={true}>Tutorials</Subheader>
      <ListItem
        primaryText={<span>Petersen, K., & Molléri, J. S. <strong>Systematic Reviews and Maps in Software Engineering: A Tutorial.</strong> ACM/IEEE International Symposium on Empirical Software Engineering and Measurement. 2020.</span>}
        disabled="true"
        insetChildren="true"
      />
    </List>
  </div>
);

export default page;



// WEBPACK FOOTER //
// ./src/components/Home/Publications.js